interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  required?: boolean;
}

export default function Label(props: Readonly<Props>) {
  const { children, required } = props;
  return (
    <label className="text-neutral-900 text-sm font-medium not-italic" {...props}>
      {children}
      {required && <span className="text-red-500">*</span>}
    </label>
  );
}
